// tabConfigs.js - Updated to include dynamic route-specific charts
import { getUniqueRoutesFromTripData } from "./dataMapping";

export const getTabConfigurations = (t, processedCharts, tripReportData) => {
    // Get unique routes from trip data to create dynamic route charts
    const uniqueRoutes = tripReportData ? getUniqueRoutesFromTripData(tripReportData) : [];
    
    // Generate route-specific charts
    const routeSpecificCharts = uniqueRoutes.map(routeName => {
        // Find the trip data for this route
        const tripChartState = processedCharts.find(chart => chart.reportType === "trip")?.chartState;
        
        return {
            id: `route_specific_trips_${routeName.replace(/\s+/g, '_')}`,
            title: `${routeName} - Vehicle Trips`,
            reportType: "trip",
            category: "vehicles",
            chartType: "barGraph",
            color: getRouteColor(routeName),
            width: 320,
            height: 280,
            routeName: routeName, // Add route name to identify which route this chart is for
            chartState: tripChartState || { loading: false, data: null, error: null }
        };
    });

    return [
        {
            label: t("Overview"),
            charts: processedCharts.filter(
                (chart) =>
                    chart.id !== "overspeed_timeline" &&
                    chart.id !== "dead_halt_count" &&
                    chart.id !== "inactive_halt_count" &&
                    chart.id !== "dead_halt_duration" &&
                    chart.id !== "inactive_halt_duration" &&
                    chart.id !== "distance_covered" &&
                    chart.id !== "trip_timeline" &&
                    chart.id !== "trip_gantt_timeline" &&
                    chart.id !== "route_specific_trips"
            ),
        },
        {
            label: t("Speed Analytics"),
            charts: processedCharts.filter(
                (chart) =>
                    chart.id === "maximum_speed" ||
                    chart.id === "average_speed" ||
                    chart.id === "overspeed_incidents" ||
                    chart.id === "overspeed_timeline"
            ),
        },
        {
            label: t("Trip Metrics"),
            charts: processedCharts.filter(
                (chart) =>
                    chart.id === "trip_status" ||
                    chart.id === "total_trips" ||
                    chart.id === "trips_by_time_of_day" ||
                    chart.id === "trip_gantt_timeline"
            ),
        },
        {
            label: t("Route Analytics"),
            charts: [
                ...processedCharts.filter(
                    (chart) =>
                        chart.id === "total_route_deviation" || 
                        chart.id === "trips_per_route"
                ),
                ...routeSpecificCharts // Add dynamic route-specific charts
            ],
        },
        {
            label: t("Vehicle Analytics"),
            charts: processedCharts.filter(
                (chart) =>
                    chart.id === "total_runtime" ||
                    chart.id === "dead_halt_count" ||
                    chart.id === "inactive_halt_count" ||
                    chart.id === "dead_halt_duration" ||
                    chart.id === "inactive_halt_duration" ||
                    chart.id === "stops_visited" ||
                    chart.id === "distance_covered"
            ),
        },
    ];
};

// Helper function to assign colors to routes
const getRouteColor = (routeName) => {
    const colors = [
        "#E74C3C", // Red
        "#3498DB", // Blue
        "#2ECC71", // Green
        "#F39C12", // Orange
        "#9B59B6", // Purple
        "#1ABC9C", // Teal
        "#E67E22", // Dark Orange
        "#34495E", // Dark Blue Gray
        "#16A085", // Dark Teal
        "#27AE60", // Dark Green
        "#2980B9", // Darker Blue
        "#8E44AD", // Dark Purple
    ];
    
    // Simple hash function to consistently assign colors based on route name
    let hash = 0;
    for (let i = 0; i < routeName.length; i++) {
        const char = routeName.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32-bit integer
    }
    
    return colors[Math.abs(hash) % colors.length];
};